import { createSelector } from 'reselect'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LikeV1, PaginatedPostsV1, PostV1 } from '../apis/door/PostV1'
import { RootState } from '../store'

interface AlertState {
  isOpen: boolean
  text: string
  severity: 'error' | 'warning' | 'info' | 'success'
  position?: 'upper' | 'bottom'
}

/**
 * posts storeの型定義
 */
const initialState: AlertState = {
  isOpen: false,
  text: '',
  severity: 'info',
  position: 'bottom'
}

/**
 * selector
 * @param state
 * @returns
 */
export const alertSelector = (state: RootState) => state.alert

export const getIsOpen = createSelector(alertSelector, (alert) => alert.isOpen)
export const getText = createSelector(alertSelector, (alert) => alert.text)
export const getSeverity = createSelector(
  alertSelector,
  (alert) => alert.severity
)
export const getPosition = createSelector(
  alertSelector,
  (alert) => alert.position || 'bottom'
)

/**
 * SLICE
 * reducer
 */
const alert = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert(
      state,
      action: PayloadAction<{
        text: string
        severity: 'error' | 'warning' | 'info' | 'success'
        position?: 'upper' | 'bottom'
      }>
    ) {
      const alert = action.payload

      state.text = alert.text
      state.severity = alert.severity
      state.isOpen = true
      state.position = alert.position || 'bottom'
    },
    setClose(state) {
      state.isOpen = false
    }
  }
})

export default alert
